import { Experience, Education, SpeakingEvent, Teaching } from '../types';

export const experiences: Experience[] = [
    {
        id: '01tech',
        company: '01tech',
        position: 'Tech Lead / Team Lead',
        period: 'Nov 2024 — Present',
        location: 'Москва',
        shortDescription: "Проектирование и разработка высоконагруженных распределенных систем, создание инфраструктурных платформ и руководство кросс-функциональными командами.",
        fullDescription: "За время работы реализовал несколько критически важных инфраструктурных проекта. Специализировался на создании отказоустойчивых систем с использованием Java и gRPC, проектировании распределенных хранилищ и инструментов для автоматизации разработки (SDK, CLI). Сочетал роли системного архитектора, ведущего разработчика и тимлида.",
        achievements: [
            "Обеспечил уровень отказоустойчивости критических систем 99.99+%",
            "Выстроил процессы взаимодействия в кросс-функциональной команде, обеспечив поставку сложного продукта от концепта до реализации",
            "Создал переиспользуемые технологические компоненты (KV-store, configurations-SDK), которые внедрили продуктовые команды компании.",
            "Оптимизировал эксплуатационные расходы, заменив стандартные open-source решения на более эффективные внутренние разработки"
        ],
        projects: [
            {
                name: "Система управления конфигурациями",
                description: "Распределенная отказоустойчивая система управления конфигурациями с поддержкой консенсуса и real-time подписок на изменения.",
                role: "Architect / Tech Lead / Team Lead",
                technologies: ["Java", "JRaft", "gRPC", "Spring", "Go", "Key-Value Store"],
                achievements: [
                    "Спроектировал и защитил на арх-комитете архитектуру с уровнем доступности 99.99+%",
                    "Разработал ядро системы на базе JRaft, которое позже было выделено в отдельный shared-компонент для других сервисов",
                    "Реализовал полнофункциональный Java SDK с глубокой интеграцией в Spring",
                    "Создал административный CLI-инструмент на языке Go",
                    "Координировал разработку клиентских библиотек на Go, Python и Node.js"
                ]
            },
            {
                name: "Система событийного мониторинга",
                description: "Система для комплексного мониторинга инфраструктуры и сервисов с поддержкой различных протоколов передачи данных.",
                role: "Architect / Tech Lead",
                technologies: ["Java", "HTTP/S", "TCP", "JDBC", "DNS", "Service Discovery"],
                achievements: [
                    "Реализовал механизм автоматического обнаружения (autodiscovery) сервисов в инфраструктуре",
                    "Внедрил поддержку проверок по протоколам HTTP/S, TCP, TLS, JDBC и DNS",
                    "Реализовал движок исполнения пользовательских скриптов на JS и Python, позволяющий гибко настраивать логику мониторинга и управлять статусами (зажигать монитор) на основе результата выполнения.",
                ]
            },
            {
                name: "Система создания облачных операторов",
                description: "Платформа для развертывания и управления облачными операторами с использованием распределенного хранилища Cassandra.",
                role: "Architect / Tech Lead",
                technologies: ["Java", "Cassandra", "gRPC", "Distributed Systems"],
                achievements: [
                    "Разработал кастомное embedded-решение на базе Cassandra и оптимизировал процесс обслуживания данных (заменил Cassandra Reaper собственной встроенной реализацией)",
                    "Спроектировал алгоритм умного размещения операторов, учитывающий топологию данных в кластере Cassandra",
                    "Успешно защитил архитектуру решения на арх-комитете"
                ]
            }
        ],
        technologies: [
            "Java", "Go", "gRPC", "Spring Framework", "Cassandra",
            "JRaft", "Distributed Systems", "Consensus Algorithms",
            "SQL/NoSQL", "Monitoring", "Architecture Design"
        ]
    },
    {
        id: 'vk-cloud-lead',
        company: 'VK (ex-Mail.ru Group)',
        position: 'Senior Java Developer / Architect',
        period: 'Jan 2023 — Nov 2024',
        location: 'Москва',
        shortDescription: "Разработка и архитектурное развитие высоконагруженной инфраструктуры для Cassandra, облака и систем хранения данных экзобайтного масштаба.",
        fullDescription: "Занимался глубокой доработкой распределенных систем (Cassandra, cold-storage, s3), реализация сетевых подсистем облака (IPv6, Spine & Leaf, Host-based Firewall) и сопровождением миграции в облако.",
        achievements: [
            "Поддерживал кластеры Cassandra до 1000 нод, обеспечив стабильную работу более 100 кластеров для OK, Dzen и VK Video.",
            "Успешно реализовал поддержку IPv6 на парке из 20 000 физических серверов и в ядре системы Одноклассников.",
            "Разработал систему восстановления данных для хранилища объемом 1.5 EB (Exabytes).",
            "Обеспечил безопасность сети для 100 000+ контейнеров через разработку Host-based Firewall."
        ],
        projects: [
            {
                name: "Cassandra Core Optimization",
                description: "Глубокая модификация Apache Cassandra для нужд высоконагруженных сервисов (OK, Dzen, VK Video).",
                role: "Senior Developer / Architect",
                technologies: ["Java", "Distributed Systems", "Storage Engine"],
                achievements: [
                    "Реализовал приоритизацию дискового ввода-вывода (I/O) между пользовательскими запросами и служебными задачами (compaction, repair).",
                    "Внедрил механизм Strongly Consistent schema changes.",
                    "Исправил критические баги в подсистемах streaming, repair и compaction на масштабах 1000 нод."
                ]
            },
            {
                name: "OCS (One-Cold-Storage) Data Integrity",
                description: "Система обеспечения целостности и восстановления данных в одном из крупнейших в России хранилищ контента.",
                role: "Storage Engineer",
                technologies: ["Java", "Storage Algorithms", "Data Recovery"],
                achievements: [
                    "Разработал алгоритмы поиска и восстановления поврежденных данных для 1.5 EB данных (включая весь видеоконтент VK Video).",
                    "Минимизировал риски потери данных при деградации носителей на огромных масштабах."
                ]
            },
            {
                name: "Cloud IPv6 & Network Infrastructure",
                description: "Полный цикл внедрения IPv6 в облачную инфраструктуру и core-системы.",
                role: "Senior developer",
                technologies: ["Java", "eBPF", "Networking", "RPC"],
                achievements: [
                    "Добавил поддержку dual-stack во внутренний RPC-фреймворк.",
                    "Добавил IPv6 в eBPF-шейпер трафика для управления полосой пропускания на серверах.",
                    "Реализовал систему выделения, назначения и анонсирования IPv6 адресов контейнерам"
                ]
            },
            {
                name: "Host-based Firewall",
                description: "Система фильтрации трафика на уровне хоста для защиты контейнеризированной среды.",
                role: "Senior Developer",
                technologies: ["grpc", "java", "iptables"],
                achievements: [
                    "Реализовал системы хранения, кеширования, проверки состояния и доставки систем фильтрации трафика",
                    "Система успешно эксплуатируется в среде с более чем 100 000 контейнеров.",
                    "Обеспечил высокую производительность фильтрации без значительных накладных расходов на CPU."
                ]
            },
            {
                name: "Cloud Migration",
                description: "Архитектурное сопровождение и техническая координация процесса миграции высоконагруженных сервисов экосистемы (ВКонтакте, Дзен, Mail.ru) в облачную инфраструктуру. ",
                role: "Cloud Solutions Architect / Migration Lead",
                technologies: ["Technical Communication", "Workflow Automation", "Technical Onboarding", "CI/CD", "Cloud"],
                achievements: [
                    "Провел серию воркшопов и консультаций по архитектуре распределенных систем, что позволило командам успешно мигрировать в облако.",
                    "Спроектировал и реализовал ряд инфраструктурных фич «под ключ» (например, кастомные контроллеры или доработки API облака), закрыв критические потребности продуктовых команд.",
                    "Помог нескольким командам пересмотреть архитектуру в пользу адаптированной под динамическое масштабирование облака.",
                ]
            }
        ],
        technologies: [
            "Java", "Go", "eBPF", "Cassandra", "gRPC", "Cgroups",
            "IPv6", "RPC Frameworks", "Distributed Systems"
        ],
    },
    {  id: "ok-ru-experience",
        company: "Одноклассники (VK)",
        position: "Developer -> Senior Software Engineer",
        period: "Jan 2020 – Jan 2023",
        location: "Москва",
        shortDescription: "Разработка высоконагруженных core-систем платформы и развитие сервисов монетизации и подарков с нагрузкой до 1 млрд дарений подарков в сутки.",
        fullDescription: "Занимался развитием критически важной инфраструктуры социальной сети: внутреннего форка Cassandra, системы конфигураций и RPC-фреймворка. Параллельно руководил техническим развитием сервиса подарков и систем монетизации, фокусируясь на отказоустойчивости, оптимизации хранения медиа-контента и автоматизации бизнес-процессов.",
        technologies: ["Java", "Cassandra", "MsSql", "Distributed Systems", "RPC", "High Load", "Observability"],
        achievements: [
            "Обеспечил бесперебойную работу сервиса подарков при нагрузке 1 млрд событий в сутки.",
            "Повысил доступность системы платежей и подписок за счет миграции с SQL на NoSQL.",
            "Сократил Time-to-Market для промо-проектов в 300 раз (с 2 недель до 1 часа).",
            "Оптимизировал пайплайн загрузки медиа-контента (фото/GIF).",
            "Нашел и устранил критические баги в Сassandra (internal fork)",
        ],
        projects: [
            {
                name: "Platform Infrastructure Development",
                description: "Развитие внутренних систем платформы: доработка собственного форка Cassandra, системы распределенной конфигурации и внутреннего RPC-протокола.",
                role: "Senior Software Engineer / Architect",
                technologies: ["Java", "Cassandra", "Distributed Systems", "RPC", "High Performance"],
                achievements: [
                    "Проведение архитектурных ревью для смежных команд",
                    "Улучшение производительности и стабильности базовых компонентов системы"
                ]
            },
            {
                name: "Data Migration: MsSql to Cassandra",
                description: "Масштабный проект по переносу данных платежной системы и подписок (таблицы 1-10 Тб) с реляционной БД на Cassandra без простоя сервиса.",
                role: "Senior Software Engineer / Architect",
                technologies: ["MsSql", "Cassandra", "Data Migration", "High Availability"],
                achievements: [
                    "Разработка архитектуры денормализованных данных",
                    "Реализация механизма плавного переключения (zero-downtime)",
                    "Значительное увеличение показателя доступности (SLA) сервиса платежей"
                ]
            },
            {
                name: "High-load Gifting & Monetization Service",
                description: "Развитие и эксплуатация сервиса подарков с экстремальными нагрузками и сложной бизнес-логикой.",
                role: "Java Developer -> Senior Software Engineer",
                technologies: ["Java", "Cassandra", "Observability", "DWH"],
                achievements: [
                    "Интеграция с ML/DWH для внедрения рекомендательных систем",
                    "Эксплуатация и поддержка 4-х кластеров Cassandra",
                    "Внедрение сквозного сбора метрик по асинхронному пайплайну платежей",
                    "Оптимизация основного загрузчика фото и GIF/видео",
                    "Сокращение цикла запуска промо-проектов с 14 дней до 1 часа",
                    "Реализация массовых операций (рассылка всем друзьям, массовое принятие)",
                    "Улучшение показателей отказоустойчивости и доступности различных сервисов подписок и подарков"
                ]
            },
        ]
    },
];

export const education: Education[] = [
    {
        institution: 'Новосибирский Государственный Университет (НГУ)',
        degree: 'Бакалавр',
        field: 'Механико-математический факультет, Математика и компьютерные науки',
        period: '2015 — 2019',
    },
];

export const speakingEvents: SpeakingEvent[] = [
    { title: 'Эксперт: "ThreadLocal устарел? Детальное сравнение со ScopedValue"', conference: 'Joker 2025', date: 'Oct 2024', link: 'https://jokerconf.com/talks/71877f4a83724875a51be78b166fea83/' },
    { title: 'Программный комитет', conference: 'XIII «СТАЧКА» 2025', date: 'Apr 2025', link: 'https://ul25.nastachku.ru' },
    { title: 'Эксперт: "Cassandra: почему мой запрос тормозит?"', conference: 'Jpoint 2025', date: 'Apr 2025', link: 'https://jpoint.ru/archive/2025/persons/c360e9d9f14b4a4c8b9a03db25c6eba2/' },
    { title: 'Эксперт: "Apache Cassandra: 8 лет в продакшене"', conference: 'Jpoint 2024', date: 'Apr 2024', link: 'https://jpoint.ru/archive/2024/talks/9a8a13a1fd1f43598331d4c3f06a0275/' },
    { title: 'Эксперт: "Память Cassandra по полочкам. Cassandra memory footprint"', conference: 'Jpoint 2024', date: 'Apr 2024', link: 'https://jpoint.ru/archive/2024/talks/1f5f202e66d54f2ab46e8c9a99aa34f4/' },
    { title: 'Активность: "ASK EXPERT"', conference: 'Jpoint 2024', date: 'Apr 2024', link: 'https://jpoint.ru/archive/2024/talks/1d1b90b2bc3946ed9d8149d5f19a3d61/' },
    { title: 'Спикер: "С SQL на Cassandra"', conference: 'Joker 2023', date: 'Oct 2023', link: "https://jokerconf.com/archive/2023/talks/cc1e610803354cc586b14da81b63e573/" },
    { title: 'Эксперт: "Асинхронный транспорт Cassandra"', conference: 'Joker 2022', date: 'Nov 2022', link: 'https://jokerconf.com/archive/2022/talks/16056ea7da6f47b8a4e356f5a0b87643/' },
];

export const teaching: Teaching[] = [
    { project: 'Образовательный центр VK в Политехе', description: 'Разработка и проведение курсов по Highload и NoSQL, а также проведение вступительных технических интервью для оценки уровня подготовки абитуриентов', link: 'https://ok.ru/technopolis', years: '2022-2024' },
    { project: 'Магистратура ИТМО: Распределённые веб-сервисы', description: 'Разработка и проведение лекционных и семинарских занятий по курсам "Проектирование высоконагруженных систем" (Highload) и "Нереляционные базы данных" (NoSQL)', link: 'https://education.vk.company/program/235', years: '2024' },
    { project: 'Приглашенный лектор', description: 'Приглашенный лектор в различных университетах (ИТМО, проектная школа от ВШЭ, МИРЭА) по тематике проектирования высоконагруженных систем' },
];
